import type { Post } from '@/types'
import { getPostsByType } from '@/utils/endpoint'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import CarrouselArrowIconMiddle from '../Icon/CarrouselArrowIconMiddle'
import BlogCard from './BlogCard'

const BlogList = () => {
  const settings: Settings = {
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    speed: 800,
    autoplay: false,
    autoplaySpeed: 5000,
    nextArrow: <CarrouselArrowIconMiddle type='nextBlog' />,
    prevArrow: <CarrouselArrowIconMiddle type='prevBlog' />,
  }
  const [tips, setTips] = useState<Post[]>([])
  const [promotions, setPromotions] = useState<Post[]>([])

  useEffect(() => {
    getPostsByType('tips').then(d => setTips(d || []))
    getPostsByType('promotion').then(d => setPromotions(d || []))
  }, [])
  return (
    <>
      <section className='blogList mt-3 pb-[20px]'>
        <div className='head-sec relative ml-auto mr-auto text-center'>
          <div className='flex gap-4'>
            <div className='w-[calc(50%-8px)] rounded-lg bg-white p-5'>
              <div className='flex items-start justify-between'>
                <h4 className='mb-1 px-2 text-HeadlineMedium font-bold'>
                  Khuyến mãi
                </h4>
                <Link
                  href='/post/khuyen-mai'
                  className='mt-[4px] px-2 text-primary'
                >
                  Xem tất cả
                </Link>
              </div>
              <Slider {...settings}>
                {(promotions || []).map((post, index) => (
                  <div key={index} className='p-1'>
                    <BlogCard post={post} />
                  </div>
                ))}
              </Slider>
            </div>

            <div className='w-1/2 rounded-lg bg-white p-5'>
              <div className='flex items-start justify-between'>
                <h4 className='mb-1 px-2 text-HeadlineMedium font-bold'>
                  Mẹo vặt
                </h4>
                <Link
                  href='/post/meo-vat'
                  className='mt-[4px] px-2 text-primary'
                >
                  Xem tất cả
                </Link>
              </div>
              <Slider {...settings}>
                {(tips || []).map((post, index) => (
                  <div key={index} className='p-1'>
                    <BlogCard post={post} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default BlogList
